export default [
  {
    uid: 'acorns',
    label: 'ACORNS data management platform',
    description: 'ACORNS is a versatile platform that can be customized to work with data from various environmental disciplines',
    image: 'oak-leaf1.jpg',
    active: true,
    date: '2019-01-01',
    tags: ['data management']
  },
  {
    uid: 'ouzel',
    label: 'Ouzel Land Management Application',
    description: 'Ouzel is an implementation of the ACORNS platform that aims to solve the problems faced by land trusts',
    image: 'ouzel-option1.jpg',
    active: true,
    date: '2020-01-01',
    tags: ['acorns', 'data management']
  },
  {
    uid: 'aermod',
    label: 'AERMOD R Library GUI',
    description: 'A web-based user interface to run R code used in AERMOD modeling',
    image: 'aermod-option2.jpg',
    active: true,
    date: '2016-01-01',
    tags: ['R', 'aermod']
  },
  {
    uid: 'aermod-service',
    label: 'AERMOD Service',
    description: 'A hosted service to build, evaluate and run AERMOD dispersion models',
    image: 'aermod-option1.jpg',
    active: true,
    date: '2017-08-01',
    tags: ['R', 'aermod', 'data management']
  },
  {
    uid: 'diesel',
    label: 'Diesel Monitoring Citizen Science Application',
    description: 'An application that allows citizens to collect, upload, and visualize data while working with scientists for review and guidance',
    image: 'diesel-option1.jpg',
    active: true,
    date: '2019-01-01',
    tags: ['acorns', 'diesel', 'data management','monitoring']
  },
  {
    uid: 'oak-model',
    label: 'Oregon White Oak Model',
    description: "Accuracy assessment of a remote sensing oak tree model.",
    image: 'oak_map_example.jpg',
    active: true,
    date: '2019-01-01',
    tags: ['R', 'statistics', 'remote-sensing', 'diesel']
  },
].map( d => ({ ...d, route: `/projects/${d.uid}` }));
